export default __webpack_public_path__ + "static/media/thumb.266a93f2.png";